// extracted by mini-css-extract-plugin
export var errorIcon = "_nh-1";
export var nameLogo = "_nh-0";